var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 56,
    viewBox: "0 0 64 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 35.1992C13.0559 35.1992 6.3999 44.7992 6.3999 51.1992V60.7992H57.5999V51.1992C57.5999 44.7992 50.9439 35.1992 31.9999 35.1992Z",
    fill: "#45444B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 31.9992C39.953 31.9992 46.4001 25.5521 46.4001 17.5992C46.4001 9.64632 39.953 3.19922 32.0001 3.19922C24.0472 3.19922 17.6001 9.64632 17.6001 17.5992C17.6001 25.5521 24.0472 31.9992 32.0001 31.9992Z",
    fill: "#45444B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.dc3fdcc696965cf168065834f644b9a7.svg";
export { ForwardRef as ReactComponent };